module.exports = __webpack_public_path__ + "img/working-freelancer.f34ea3c2.png";